import { render, staticRenderFns } from "./SfoxExchangeInput.vue?vue&type=template&id=23492c22&"
import script from "./SfoxExchangeInput.vue?vue&type=script&lang=ts&"
export * from "./SfoxExchangeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports